import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";

const STEPS = ["Height", "Weight", "Build", "Fit"];
// (Returns form initial state photo_urls is an array now)


export default function SizeFinder() {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({ height_cm: 175, weight_kg: 72, build: "athletic", preferred_fit: "tailored" });
  const [result, setResult] = useState(null);

  const submit = async () => {
    try {
      const { data: r } = await api.post("/size-finder", { ...data, height_cm: Number(data.height_cm), weight_kg: Number(data.weight_kg) });
      setResult(r); toast.success(`We recommend ${r.shirt_size} shirts.`);
    } catch (e) { toast.error("Failed"); }
  };

  return (
    <main className="sq-container py-12" data-testid="size-finder-page">
      <div className="sq-eyebrow text-squire-jeans">Smart Sizing</div>
      <h1 className="font-display text-5xl md:text-6xl mt-2">Smart Size Finder</h1>
      <p className="text-[#4B5563] mt-3 max-w-xl">Four questions. A confident size with a confidence score — so you stop second-guessing.</p>

      <div className="mt-10 max-w-2xl">
        <div className="flex gap-2 mb-8">
          {STEPS.map((s, i) => (
            <div key={i} className={`flex-1 h-1 ${i <= step ? "bg-squire-jeans" : "bg-black/10"}`} />
          ))}
        </div>

        {step === 0 && <Q label="What is your height? (cm)">
          <input data-testid="sf-height" type="number" value={data.height_cm} onChange={(e) => setData({ ...data, height_cm: e.target.value })} className="font-display text-6xl bg-transparent border-b border-black/30 focus:border-squire-jeans outline-none w-40" />
        </Q>}
        {step === 1 && <Q label="What is your weight? (kg)">
          <input data-testid="sf-weight" type="number" value={data.weight_kg} onChange={(e) => setData({ ...data, weight_kg: e.target.value })} className="font-display text-6xl bg-transparent border-b border-black/30 focus:border-squire-jeans outline-none w-40" />
        </Q>}
        {step === 2 && <Q label="How would you describe your build?">
          <div className="flex flex-wrap gap-3 mt-4">
            {["slim", "athletic", "broad", "round"].map((b) => (
              <button key={b} data-testid={`sf-build-${b}`} onClick={() => setData({ ...data, build: b })} className={`px-6 py-3 border ${data.build === b ? "border-squire-jeans bg-squire-jeans text-white" : "border-black/30"}`}>{b}</button>
            ))}
          </div>
        </Q>}
        {step === 3 && <Q label="Preferred fit?">
          <div className="flex flex-wrap gap-3 mt-4">
            {["slim", "tailored", "relaxed"].map((b) => (
              <button key={b} data-testid={`sf-fit-${b}`} onClick={() => setData({ ...data, preferred_fit: b })} className={`px-6 py-3 border ${data.preferred_fit === b ? "border-squire-jeans bg-squire-jeans text-white" : "border-black/30"}`}>{b}</button>
            ))}
          </div>
        </Q>}

        <div className="flex justify-between mt-12">
          <button data-testid="sf-back" disabled={step === 0} onClick={() => setStep((s) => s - 1)} className="sq-btn-outline disabled:opacity-30">Back</button>
          {step < STEPS.length - 1 ? (
            <button data-testid="sf-next" onClick={() => setStep((s) => s + 1)} className="sq-btn-primary">Next</button>
          ) : (
            <button data-testid="sf-submit" onClick={submit} className="sq-btn-primary">Find My Size</button>
          )}
        </div>

        {result && (
          <div className="mt-10 border-2 border-squire-jeans p-8 bg-[#F5F5F5]" data-testid="sf-result">
            <div className="sq-eyebrow text-squire-jeans">Your Profile · {result.id}</div>
            <div className="grid grid-cols-3 gap-4 mt-4">
              <div><div className="sq-eyebrow text-[10px]">Shirt</div><div className="font-display text-5xl">{result.shirt_size}</div></div>
              <div><div className="sq-eyebrow text-[10px]">Trouser</div><div className="font-display text-5xl">{result.trouser_size}</div></div>
              <div><div className="sq-eyebrow text-[10px]">Confidence</div><div className="font-display text-5xl text-squire-jeans">{result.confidence_pct}%</div></div>
            </div>
            <p className="text-sm text-[#4B5563] mt-4">Body type detected: <strong>{result.body_type}</strong> · BMI {result.bmi}</p>
            <div className="mt-6 flex gap-3 flex-wrap">
              <Link to="/fabrics" className="sq-btn-primary">Browse Fabrics</Link>
              <Link to="/bespoke" className="sq-btn-outline">Tailor a Bespoke</Link>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}
function Q({ label, children }) {
  return (
    <div>
      <div className="sq-eyebrow">Question</div>
      <h2 className="font-display text-3xl md:text-4xl mt-3">{label}</h2>
      <div className="mt-6">{children}</div>
    </div>
  );
}
